<template>
  <section v-lenis-scroll class="thar_banner">
    <div class="mainBanner">
      <div class="tharBanner" :style="{ backgroundImage: 'url(' + backgroundImage + ')' }">
        <div class="bannerContent">
          <img
            v-lazy="shopifyData.textImage"
            alt="Thar Banner Tex"
            loading="lazy"
            aria-hidden="true"
            aria-label="Thar Banner Text Image"
            width=""
            height=""
          />
        </div>
      </div>
      <div class="logoSection">
        <img
          v-lazy="shopifyData.logo"
          alt="Behno Logo"
          loading="lazy"
          aria-hidden="true"
          aria-label="Behno Logo"
          width=""
          height=""
        />
      </div>
    </div>
  </section>
</template>

<script>
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import Lenis from '@studio-freight/lenis'

export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    // Dynamic background image based on window width
    backgroundImage() {
      return this.windowWidth <= 768 ? this.shopifyData.mobBg : this.shopifyData.desktopBg;
    },
  },
  mounted() {
    this.updateBackgroundImage();

    // Add a resize event listener
    window.addEventListener('resize', this.updateBackgroundImage);

    // Lenis initialization with smoothWheel option
    // const lenis = new Lenis({
    //       smoothWheel: true,
    //       smooth: true,
    //       infinite: false,
    //       direction: "vertical",
    //       duration: 3,
    //       wheelMultiplier: 1,
    //       easing: (t) => t

    // });

    // Update ScrollTrigger on scroll
    // lenis.on('scroll', ScrollTrigger.update);
    // lenis.on('scroll', (e) => {
    //       if (lenis.isScrolling) {
    //             console.log("Scrolling is in progress.");
    //             console.log(e);
    //             // You can add logic here for UI feedback, like showing a loader
    //       } else {
    //             console.log("User has stopped scrolling.");
    //             // Hide loader or trigger animations
    //       }
    // });

    // // GSAP ticker for Lenis
    // gsap.ticker.add((time) => {
    //       lenis.raf(time * 1000);
    // });

    // gsap.ticker.lagSmoothing(0);
    // this.lenisInstance = lenis;

    // function raf(time) {
    //       lenis.raf(time);
    //       requestAnimationFrame(raf);
    // }

    // Start the animation frame loop
    // requestAnimationFrame(raf);

    gsap.registerPlugin(ScrollTrigger);

    const mm = gsap.matchMedia();

    mm.add('(max-width: 768px)', () => {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.tharBanner',
            start: 'top top',
            end: 'top -70%',
            scrub: 3,
            pin: true,
            pinSpacing: false,
            // markers: true
          },
        })
        .fromTo(
          '.tharBanner',
          { backgroundSize: '110%' },
          { backgroundSize: '120%', backgroundPosition: 'center center' }
        );

      gsap.timeline({
        scrollTrigger: {
          trigger: '.logoSection',
          start: 'top 70%',
          end: 'top 30%',
          scrub: 3,
          pin: true,
          // markers: true
        },
      });
    });

    // Media query for min-width: 1440px
    mm.add('(min-width: 1440px)', () => {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.tharBanner',
            start: 'top top',
            end: 'top -70%',
            scrub: 3,
            pin: true,
            pinSpacing: false,
            // markers: true
          },
        })
        .fromTo('.tharBanner', { backgroundSize: '120%' }, { backgroundSize: '130%' });

      gsap.timeline({
        scrollTrigger: {
          trigger: '.logoSection',
          start: 'top 70%',
          end: 'top 30%',
          scrub: 3,
          pin: true,
          // markers: true
        },
      });
    });

    // Media query for 1199px to 1439px
    mm.add('(min-width: 1199px) and (max-width: 1439px)', () => {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.tharBanner',
            start: 'top top',
            end: 'top -70%',
            scrub: 3,
            pin: true,
            pinSpacing: false,
          },
        })
        .fromTo('.tharBanner', { backgroundSize: '200%' }, { backgroundSize: '210%' });

      gsap.timeline({
        scrollTrigger: {
          trigger: '.logoSection',
          start: 'top 70%',
          end: 'top 30%',
          scrub: 3,
          pin: true,
        },
      });
    });

    // Media query for 769px to 1199px
    mm.add('(min-width: 769px) and (max-width: 1199px)', () => {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.tharBanner',
            start: 'top top',
            end: 'top -70%',
            scrub: 3,
            pin: true,
            pinSpacing: false,
          },
        })
        .fromTo('.tharBanner', { backgroundSize: '250%' }, { backgroundSize: '260%' });

      gsap.timeline({
        scrollTrigger: {
          trigger: '.logoSection',
          start: 'top 70%',
          end: 'top 30%',
          scrub: 3,
          pin: true,
        },
      });
    });
  },

  beforeUnmount() {
    // this.lenisInstance.destroy();
    // gsap.ticker.remove(this.lenisInstance.raf);
    window.removeEventListener('resize', this.updateBackgroundImage);
    clearTimeout(this.resizeTimeout);
  },
  methods: {
    updateBackgroundImage() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        const newWidth = window.innerWidth;
        if (newWidth !== this.windowWidth) {
          this.windowWidth = newWidth;
        }
      }, 200);
    },
  },
};
</script>

<style scoped>
/* .thar_banner {
      margin-top: 40px;
} */

.tharBanner {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
}

.bannerContent {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
  padding-top: 65px;
}

.mainBanner {
  position: relative;
  overflow: hidden;
}

.bannerContent img {
  max-width: 338px;
  width: 100%;
}

.logoSection {
  height: 30vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 1;
  overflow: hidden;
}
.logoSection img {
  display: block;
  max-width: 102px;
  width: 100%;
}

@media screen and (max-width: 1200px) {
  .bannerContent img {
    max-width: 282px;
    height: auto;
  }
}
@media screen and (max-width: 768px) {
  .bannerContent {
    padding-top: 85px;
  }

  .tharBanner {
    background-position: center center;
    background-size: cover;
    height: 100vh;
  }

  .bannerContent img {
    max-width: 226px;
    width: 100%;
    max-height: 266px;
    height: 100%;
  }

  /* .logoSection {
            height: 3vh;
      } */

  .logoSection img {
    display: block;
    max-width: 102px;
    width: 100%;
  }

  .thar_banner {
    margin-top: 170px;
  }
}
</style>
